import * as styles from './EntityExtraTags.module.css'

function getTooltipLines(lines) {
  return (
    <div className={styles.tooltipContent}>
      {lines
        .filter(line => line.count)
        .map(({ count, text }) => (
          <span key={text}>
            {text} ({count})
          </span>
        ))}
    </div>
  )
}

export function getTooltipText(text, count) {
  return count ? `${text} (${count})` : text
}

export function getTooltipEmail({ all, error, t, unread }) {
  return getTooltipLines([
    { count: all, text: t('RequestTable.AllEmailToolTipKey') },
    { count: unread, text: t('RequestTable.IconUnreadEmailsTooltipKey') },
    { count: error, text: t('RequestTable.IconErrorMessagesTooltipKey') },
  ])
}

export function getTooltipChat({ all, error, t, unread }) {
  return getTooltipLines([
    { count: all, text: t('RequestTable.AllChatMessagesToolTipKey') },
    { count: unread, text: t('RequestTable.IconUnreadChatMessagesTooltipKey') },
    { count: error, text: t('RequestTable.ErrorChatMessagesToolTipKey') },
  ])
}

export function getTooltipEpost({ all, error, t }) {
  return getTooltipLines([
    { count: all, text: t('Table.AllEpostToolTipKey') },
    { count: error, text: t('Table.IconErrorEpostTooltipKey') },
  ])
}
